import {Ticket, AIModelId} from './types';
import {startSession, resetSession} from './session';
import {rawRequest, responseError} from './http';
import {consumeDraftStream} from './draftStream';
import {withDeadline} from './requestDeadline';
export {startSession} from './session';

async function authenticatedRequest(path: string, options: RequestInit = {}): Promise<Response> {
  const response = await rawRequest(path, options);
  if (response.status === 401) resetSession();
  if (!response.ok) throw await responseError(response, 'Something went wrong. Please try again.');
  return response;
}

export async function api<T = unknown>(path: string, options: RequestInit = {}): Promise<T> {
  await startSession();
  return withDeadline(async signal => {
    const response = await authenticatedRequest(path, {...options, signal});
    const result = await response.json() as T;
    if (path === '/session' && options.method === 'DELETE') resetSession();
    return result;
  }, {
    timeoutMs: path === '/gmail/sync' ? 110000 : 15000,
    message: 'The server response took too long. Please try again without clearing browser data.',
    parentSignal: options.signal,
  });
}

export const patchTicket = (id: string, patch: Partial<Ticket>): Promise<Ticket> =>
  api<Ticket>(`/tickets/${id}`, {method: 'PATCH', body: JSON.stringify(patch)});

export async function generateDraft(id: string, tone: string, progress: (value: string) => void, modelId?: AIModelId): Promise<Ticket> {
  await startSession();
  return withDeadline(async signal => {
    const response = await authenticatedRequest(`/tickets/${id}/generate`, {method: 'POST', body: JSON.stringify({tone, model_id: modelId}), signal});
    if (!response.body) throw new Error('The draft response is empty. Please try again.');
    return consumeDraftStream(response.body, progress);
  }, {timeoutMs: 200000, message: 'Draft generation took too long. Your ticket is saved; retry when the connection recovers.'});
}